import { Amplify } from "aws-amplify";

export class Configuration {
    public static apply(configuration: any): void {
        Amplify.configure(configuration);
    }

    public static applyCognito(pool: string, clientId?:string): void {
        Amplify.configure(Configuration.generate(pool, clientId));
    }

    public static generate(pool: string, clientId?:string): any {
        return {
            "aws_cognito_region": Configuration.getRegion(pool),
            "aws_user_pools_id": pool,
            "aws_user_pools_web_client_id": clientId,
            "aws_cognito_login_mechanisms": [
                "EMAIL"
            ]
        }
    }

    private static getRegion(pool: string): string {
        return pool.split("_")[0];
    }
}
